import * as ko from 'knockout';
import entityBase from 'entityBase';

export class request_text extends entityBase {
    text          : KnockoutObservable<string>;
    text_line_code: KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.text           = ko.observable(item.text);
        this.text_line_code = ko.observable(item.text_line_code).extend({ maxLength: 32 });
    }
}


